import React, { useEffect, useState } from 'react'
import { View, StyleSheet, Image } from 'react-native'
import Colors from '../../../constants/Colors'
import { SpacingStyles } from '../../../styles'
import { Portal } from 'react-native-paper'
import MainContainer from '../../MainContainer/MainContainer'
import { useNavigation } from '@react-navigation/core'
import PhoneInputForm from '../../formElements/PhoneInputForm'
import { BookedSessions } from './BookedSessions'
import { AvailableSessions } from './AvailableSessions'
import BehaviorDialog from './BehaviorDialog'
import { NormalSnackbar } from '../../snackbars/Snackbar'
import { getAvailableDates, getBookedSessions } from '../../../services/api/snakSammen'
import Layout from '../../../constants/Layout'

export default function SnakSammenOversigt() {
  const navigation = useNavigation()

  const [errorMessage, setErrorMessage] = useState(null)
  const [showHelpPopup, setShowHelpPopup] = useState(false)
  const [availableDates, setAvailableDates] = useState([])
  const [bookedSessions, setBookedSessions] = useState([])

  useEffect(() => {
    getAvailableDates().then(setAvailableDates)
    getBookedSessions().then(setBookedSessions)
  }, [])

  async function handleRefresh() {
    await getBookedSessions().then(setBookedSessions)
    await getAvailableDates().then(setAvailableDates)
  }

  useEffect(() => {
    navigation.setOptions({
      title: 'SnakSammen | Boblberg',
      headerBackTitle: ' ',
      headerStyle: { 
        backgroundColor: Colors.background,
        borderBottomColor: 'transparent',
        elevation: 0, // remove shadow on Android
        shadowOpacity: 0,
        height: 100
      },
      headerTitle: () => (
        <Image
          style={styles.logo}
          resizeMode="contain"
          source={{ uri: 'https://filer.boblberg.dk/assets/img/snaksammen/snaksammen-logo.png' }}
          accessibilityLabel={'SnakSammen logo'}
          accessibilityIgnoresInvertColors
        />
      ),
    })
  }, [])

  return (
    <Portal.Host>
      <MainContainer>
        <View style={styles.widthHeight}>
          <PhoneInputForm />
          <BookedSessions bookedSessions={bookedSessions} handleRefresh={handleRefresh} />

          <AvailableSessions
            handleRefresh={handleRefresh}
            availableDates={availableDates}
            setAvailableDates={setAvailableDates}
            setErrorMessage={setErrorMessage}
          />

          <BehaviorDialog
            visible={showHelpPopup}
            onPress={() => setShowHelpPopup(true)}
            close={() => setShowHelpPopup(false)}
          />
        </View>
      </MainContainer>
      <NormalSnackbar
        style={styles.errorSnackbar}
        visible={errorMessage !== null}
        onDismiss={() => setErrorMessage(null)}
        duration={8000}
      >
        {errorMessage}
      </NormalSnackbar>
    </Portal.Host>
  )
}

const styles = StyleSheet.create({
  widthHeight: {
    backgroundColor: Colors.background,
    flex: 1,
    ...SpacingStyles.widthAndHeight,
  },
  errorSnackbar: {
    position: 'absolute',
    bottom: 10,
    backgroundColor: Colors.errorBackground,
    color: Colors.white,
  },
  logo: {
    width: 200,
    height: Layout.isSmallDevice ? 60 : 70  
  }
})
